/* eslint-disable import/no-anonymous-default-export */
import { cloneDeep, iteratee } from "lodash";
import React, { useEffect, useState } from "react";
import colors from "../../config/colors";
import { RiBankFill, RiPhoneFill } from "react-icons/ri";
import { MdEmail } from "react-icons/md";
import { IoLocationSharp, IoPersonCircle } from "react-icons/io5";
import { IoIosMail } from "react-icons/io";
import { BiPlus } from "react-icons/bi";
import { AiFillTag } from "react-icons/ai";
import AppInput from "../../common/AppInput";
import AppButton from "../../common/AppButton";
import LabelText from "../../common/LabelText";
import validation from "../../common/validation";
import api from "../../config/api";
import focusInputByName from "../../common/focusInputByName";
import { Modal } from "react-bootstrap";
import { toast } from "react-toastify";
import { useNavigate, useParams } from "react-router-dom";
import numberFormat from "../../common/numberFormat";
import { useQuery, useQueryClient } from "@tanstack/react-query";
import {
  getOrganizationByid,
  getOrganizations,
} from "../../stores/OrganizationStore";
import { getLocations } from "../../stores/LocationStore";

const size = 25;
const formInit = {
  name: "",
  careOf: "",
  phone: "",
  email: "",
  clientType: "newClient",
  billingAddress: "",
  locations: [
    {
      title: "",
      tag: "",
      incharge: "",
      contact: "",
    },
  ],
};

export default function QuotationCreateModel() {
  const Body = ({ onDone, quotation }) => {
    const navigate = useNavigate();
    const [disabled, setDisabled] = useState(false);
    const [form, setForm] = useState(cloneDeep(formInit));
    const [locations, setLocations] = useState();
    const [addLocButonDisabled, setAddLocButonDisabled] = useState(false);
    const queryClient = useQueryClient();

    const { data: organizations } = useQuery({
      queryFn: () => getOrganizations(),
      queryKey: ["organizations"],
    });

    const { data: organization } = useQuery({
      queryFn: () => getOrganizationByid(form.client?._id),
      queryKey: ["organization", form.client?._id],
    });

    const { data: locationsData } = useQuery({
      queryFn: () => getLocations(),
      queryKey: ["locations"],
    });

    useEffect(() => {
      if (form.client?._id) {
        const locs = organization?.locations?.map((loc) => {
          const found = locationsData.find((item) => item._id === loc);
          return found;
        });

        setLocations(locs);
      }
    }, [organization]);

    const handleLocationChange = ({ target }, ind) => {
      const value = target.value;
      const name = target.name;
      const locations = [...form.locations];
      locations[ind][name] = value;

      setForm({ ...form, locations });
    };

    const handleChange = ({ target }) => {
      const name = target.name;
      const value = target.value;
      setDisabled(false);

      if (name === "clientType") {
        setForm({
          ...cloneDeep(formInit),
          [name]: value,
        });
      } else if (name === "client") {
        setForm({
          ...form,
          [name]: value,
          location: [],
          attention: "Property Manager",
        });
      } else {
        setForm({ ...form, [name]: value });
      }
    };

    const handleLocSelect = ({ target }) => {
      const name = target.name;
      const value = target.value;
      if (value?.length) {
        setForm({
          ...form,
          [name]: value,
          attention: `${value[0].incharge}\n${value[0].tag}`,
        });
      } else {
        setForm({
          ...form,
          [name]: "",
          attention: "Property Manager",
        });
      }
    };

    const addLocation = async () => {
      if (
        form.locations[0]?.incharge &&
        form.locations[0]?.tag &&
        form.locations[0]?.title
      ) {
        setAddLocButonDisabled(true);
        const res = await api.put("organizations", {
          _id: form.client?._id,
          locations: [...locations, ...form.locations],
        });

        if (!res.ok) {
          setAddLocButonDisabled(false);
          return toast.error(res.originalError.message);
        }

        setAddLocButonDisabled(false);
        toast.success("New location added.");

        // Invalidate and wait for refetch
        await queryClient.invalidateQueries(["organizations"]);
        await queryClient.invalidateQueries(["locations"]);
        await queryClient.invalidateQueries(["organization", form.client?._id]);

        // Get the fresh organization data
        const freshOrgs = queryClient.getQueryData(["organizations"]);
        const updatedClient = freshOrgs?.find(
          (org) => org._id === form.client?._id
        );

        // Get fresh locations data
        const freshLocations = queryClient.getQueryData(["locations"]);
        const updatedLocs = updatedClient?.locations?.map((loc) => {
          const found = freshLocations?.find((item) => item._id === loc);
          return found;
        });

        // Update locations state for dropdown
        setLocations(updatedLocs);

        // Update form with fresh client reference
        setForm((cur) => ({
          ...cur,
          client: updatedClient, // Update with fresh reference
          locations: [
            {
              title: "",
              tag: "",
              incharge: "",
              contact: "",
            },
          ],
        }));
      }
    };

    const newLocation = () => {
      setForm({
        ...form,
        locations: [...form.locations, cloneDeep(formInit.locations[0])],
      });
    };

    const handleSubmit = async (event) => {
      setDisabled(true);
      event.preventDefault();
      // if (
      //   !validation({
      //     data: form,
      //     except: ["careOf"],
      //   })
      // )
      //   return false;

      let locations;
      let res;
      if (form.clientType === "newClient") {
        locations = form.locations.filter((i) => i.tag);
        if (locations.length === 0) {
          return focusInputByName("incharge");
        } else {
          if (!locations[0].incharge) return focusInputByName("incharge");
          if (!locations[0].title) return focusInputByName("title");
        }

        res = await api.post("organizations", {
          ...form,
          locations,
        });

        if (!res.ok) {
          setDisabled(true);
          return toast.error(res.originalError.message);
        }
        queryClient.invalidateQueries(["organizations"]);
      } else {
        locations = form.location?.filter((i) => i.tag);
        if (locations.length === 0) {
          return focusInputByName("location");
        }
      }

      const resJobId = await api.get("generate/job");
      if (!resJobId.ok) return toast.error(resJobId.originalError.message);

      const org = form.clientType === "newClient" ? res.data : organization;
      console.log({
        jobId: resJobId.data,
        organization: org._id,
        location:
          form.clientType === "newClient" ? org.locations : form.location,
        poRequestLocation: org.billingAddress,
        jobStartDate: quotation.jobStartDate,
        jobEndDate: quotation.jobEndDate,
        detailsTable: quotation.detailsTable,
        subtotal: quotation.subtotal,
        tax: quotation.tax,
        taxPercentage: quotation.taxPercentage,
        total: quotation.total,
        attention:
          form.clientType === "newClient"
            ? `${form.locations[0].incharge}\n${form.locations[0].tag}`
            : form.attention,
        helpText: `Please forward the PO for the above-mentioned scope of work at your earliest convenience. Should you require any additional information or have any queries, please do not hesitate to contact us. Thank you for doing business with us and it has been a pleasure working with your team.\n\nSincerely,\n\nOffice Administrator\nAysha`,
        invoiceID: resJobId.data?.replace("JAZ", "AZ"),
        noPo: false,
        jobIssueDate: new Date(),
      });

      const resJob = await api.post("jobs", {
        jobId: resJobId.data,
        organization: org._id,
        location:
          form.clientType === "newClient" ? org.locations : form.location,
        poRequestLocation: org.billingAddress,
        jobStartDate: quotation.jobStartDate,
        jobEndDate: quotation.jobEndDate,
        detailsTable: quotation.detailsTable,
        subtotal: quotation.subtotal,
        tax: quotation.tax,
        taxPercentage: quotation.taxPercentage,
        total: quotation.total,
        attention:
          form.clientType === "newClient"
            ? `${form.locations[0].incharge}\n${form.locations[0].tag}`
            : form.attention,
        helpText: `Please forward the PO for the above-mentioned scope of work at your earliest convenience. Should you require any additional information or have any queries, please do not hesitate to contact us. Thank you for doing business with us and it has been a pleasure working with your team.\n\nSincerely,\n\nOffice Administrator\nAysha`,
        invoiceID: resJobId.data?.replace("JAZ", "AZ"),
        noPo: false,
        jobIssueDate: new Date(),
      });

      if (!resJob.ok) return toast.error(resJob.originalError.message);

      const resDelete = await api.put("quotations", {
        _id: quotation._id,
        isDeleted: true,
      });

      if (!resDelete.ok) {
        return toast.error(resDelete.originalError.message);
      }
      queryClient.invalidateQueries(
        ["organizations"],
        ["jobs"],
        ["quotations"]
      );

      toast.success("Job has been successfully created !");

      setDisabled(true);
      setForm(cloneDeep(formInit));
      navigate(`/organizations/view/${org._id}/jobs/${resJob.data._id}`, {
        state: { data: { ...resJob.data } },
      });
      onDone && onDone();
    };

    return (
      <div onHide={() => setForm(cloneDeep(formInit))}>
        <Modal.Header closeButton>
          <span className="d-flex" style={{ alignItems: "center" }}>
            <b>Create Job</b>
          </span>
        </Modal.Header>
        <Modal.Body style={{ overflowY: "scroll" }}>
          <form id="form">
            <div
              className="d-flex"
              style={{
                flexDirection: "column",
                gap: "10px",
                padding: "0px 30px 20px 30px",
                overflowY: "auto",
              }}
            >
              {/* CLIENT DETAILS */}
              <LabelText label="Client" />
              <div
                style={{
                  display: "flex",
                  gap: 100,
                  alignItems: "center",
                }}
              >
                <div>
                  <input
                    type="radio"
                    name="clientType"
                    id="newClient"
                    value="newClient"
                    onChange={handleChange}
                    checked={form.clientType === "newClient"}
                    style={{ padding: 0, margin: 0, width: 40 }}
                  />
                  <label htmlFor="newClient">New Client</label>
                </div>
                <div>
                  <input
                    type="radio"
                    name="clientType"
                    id="exisitingClient"
                    value="exisitingClient"
                    onChange={handleChange}
                    checked={form.clientType === "exisitingClient"}
                    style={{ padding: 0, margin: 0, width: 40 }}
                  />
                  <label htmlFor="exisitingClient">Existing Client</label>
                </div>
              </div>
              <div
                style={{
                  display:
                    form.clientType === "exisitingClient" ? "none" : "flex",
                  flexDirection: "column",
                  gap: "10px",
                  padding: "0px 30px 20px 30px",
                  overflowY: "auto",
                }}
              >
                <div
                  style={{
                    display: "flex",
                    gap: 10,
                  }}
                >
                  <AppInput
                    label="Name"
                    autoFocus
                    name="name"
                    onChange={handleChange}
                    leftIcon={<RiBankFill size={size} color={colors.silver} />}
                    floatLabel
                    value={form.name}
                    inputType="text"
                    required
                  />
                  <AppInput
                    label="Care Of"
                    floatLabel
                    name="careOf"
                    value={form.careOf}
                    onChange={handleChange}
                    leftIcon={
                      <IoLocationSharp size={size} color={colors.silver} />
                    }
                  />
                </div>
                <div
                  style={{
                    display: "flex",
                    gap: 10,
                  }}
                >
                  <AppInput
                    label="Phone"
                    floatLabel
                    name="phone"
                    value={form.phone}
                    onChange={handleChange}
                    required
                    inputType="tel"
                    leftIcon={<RiPhoneFill size={size} color={colors.silver} />}
                  />
                  <AppInput
                    label="Email"
                    floatLabel
                    name="email"
                    inputType="email"
                    required
                    value={form.email}
                    onChange={handleChange}
                    leftIcon={<MdEmail size={size} color={colors.silver} />}
                  />
                </div>
                <div
                  style={{
                    display: "flex",
                    gap: 10,
                  }}
                >
                  <AppInput
                    label="Billing Address"
                    floatLabel
                    name="billingAddress"
                    value={form.billingAddress}
                    onChange={handleChange}
                    required
                    leftIcon={
                      <IoLocationSharp size={size} color={colors.silver} />
                    }
                  />
                </div>
              </div>
              <div
                style={{
                  display: form.clientType === "newClient" ? "none" : "flex",
                  paddingLeft: 30,
                  paddingRight: 30,
                }}
              >
                <AppInput
                  type="dropdown"
                  label={<span>Client</span>}
                  floatLabel
                  chip
                  options={organizations?.map((item) => ({
                    ...item,
                    name: item.name,
                  }))}
                  name="client"
                  leftIcon={<RiBankFill size={size} color={colors.silver} />}
                  onChange={handleChange}
                  value={form.client}
                  filterBy="name"
                />
              </div>
              {/* LOCATIONS DETAILS */} <LabelText label="Locations" />
              {form.clientType === "newClient" ? (
                //NEW CLIENT
                <div>
                  {form.locations.length === 1 && (
                    <div
                      style={{
                        border: "1px solid #77777720",
                        padding: 10,
                        borderRadius: 3,
                      }}
                    >
                      <div className="d-flex" style={{ gap: 20 }}>
                        <AppInput
                          label="Administrator"
                          floatLabel
                          name="incharge"
                          leftIcon={
                            <IoPersonCircle size={size} color={colors.silver} />
                          }
                          onChange={(event) => {
                            handleLocationChange(event, 0);
                          }}
                          value={form.locations[0].incharge}
                        />
                        <AppInput
                          label="Designation"
                          floatLabel
                          name="tag"
                          leftIcon={
                            <AiFillTag size={size} color={colors.silver} />
                          }
                          onChange={(event) => {
                            handleLocationChange(event, 0);
                          }}
                          value={form.locations[0].tag}
                        />

                        <AppInput
                          label="Contact"
                          floatLabel
                          name="contact"
                          leftIcon={
                            <IoIosMail size={size} color={colors.silver} />
                          }
                          onChange={(event) => {
                            handleLocationChange(event, 0);
                          }}
                          value={form.locations[0].contact}
                        />
                      </div>
                      <div className="d-flex" style={{ gap: 20 }}>
                        <AppInput
                          label="Location"
                          floatLabel
                          name="title"
                          onChange={(event) => {
                            handleLocationChange(event, 0);
                          }}
                          value={form.locations[0].title}
                          leftIcon={
                            <IoLocationSharp
                              size={size}
                              color={colors.silver}
                            />
                          }
                          rightIcon={
                            <BiPlus size={size} color={colors.silver} />
                          }
                          onClickRight={newLocation}
                        />
                      </div>
                    </div>
                  )}
                  {form.locations.length > 1 &&
                    form.locations.map((loc, ind) => {
                      const last = ind + 1 === form.locations.length;
                      return (
                        <div
                          key={String(ind)}
                          style={{
                            border: "1px solid #77777720",
                            padding: 10,
                            borderRadius: 3,
                            marginBottom: 5,
                          }}
                        >
                          <div>
                            <div className="d-flex" style={{ gap: 20 }}>
                              <AppInput
                                label="Administrator"
                                floatLabel
                                name="incharge"
                                leftIcon={
                                  <IoPersonCircle
                                    size={size}
                                    color={colors.silver}
                                  />
                                }
                                onChange={(event) => {
                                  handleLocationChange(event, ind);
                                }}
                                value={loc.incharge}
                              />
                              <AppInput
                                autoFocus
                                label="Designt"
                                floatLabel
                                name="tag"
                                leftIcon={
                                  <AiFillTag
                                    size={size}
                                    color={colors.silver}
                                  />
                                }
                                onChange={(event) => {
                                  handleLocationChange(event, ind);
                                }}
                                value={loc.tag}
                              />

                              <AppInput
                                label="Contact"
                                floatLabel
                                name="contact"
                                leftIcon={
                                  <IoIosMail
                                    size={size}
                                    color={colors.silver}
                                  />
                                }
                                onChange={(event) => {
                                  handleLocationChange(event, ind);
                                }}
                                value={loc.contact}
                              />
                            </div>
                          </div>
                          <AppInput
                            label="Location"
                            floatLabel
                            name="title"
                            onChange={(event) => {
                              handleLocationChange(event, ind);
                            }}
                            value={loc.title}
                            leftIcon={
                              <IoLocationSharp
                                size={size}
                                color={colors.silver}
                              />
                            }
                            rightIcon={
                              last && (
                                <BiPlus size={size} color={colors.silver} />
                              )
                            }
                            onClickRight={newLocation}
                          />
                        </div>
                      );
                    })}
                </div>
              ) : (
                //EXISTING CLIENT
                <div>
                  <AppInput
                    type="multi"
                    label="Job Location"
                    name="location"
                    chip
                    onChange={handleLocSelect}
                    leftIcon={<IoLocationSharp size={size} color={"silver"} />}
                    style={{ width: "90%", maxWidth: 800 }}
                    options={locations
                      ?.filter((i) => i !== undefined)
                      ?.map((i) => {
                        return {
                          ...i,
                          name: `${i.tag} - ${i.title}`,
                        };
                      })}
                    filterBy="name"
                    value={form.location}
                    required
                    floatLabel
                  />
                  {form.locations.length === 1 && (
                    <div
                      style={{
                        border: "1px solid #77777720",
                        padding: 10,
                        borderRadius: 3,
                      }}
                    >
                      <div className="d-flex" style={{ gap: 20 }}>
                        <AppInput
                          label="Administrator"
                          floatLabel
                          name="incharge"
                          leftIcon={
                            <IoPersonCircle size={size} color={colors.silver} />
                          }
                          onChange={(event) => {
                            handleLocationChange(event, 0);
                          }}
                          value={form.locations[0].incharge}
                        />
                        <AppInput
                          label="Designation"
                          floatLabel
                          name="tag"
                          leftIcon={
                            <AiFillTag size={size} color={colors.silver} />
                          }
                          onChange={(event) => {
                            handleLocationChange(event, 0);
                          }}
                          value={form.locations[0].tag}
                        />

                        <AppInput
                          label="Contact"
                          floatLabel
                          name="contact"
                          leftIcon={
                            <IoIosMail size={size} color={colors.silver} />
                          }
                          onChange={(event) => {
                            handleLocationChange(event, 0);
                          }}
                          value={form.locations[0].contact}
                        />
                      </div>
                      <div className="d-flex" style={{ gap: 20 }}>
                        <AppInput
                          label="Location"
                          floatLabel
                          name="title"
                          onChange={(event) => {
                            handleLocationChange(event, 0);
                          }}
                          value={form.locations[0].title}
                          leftIcon={
                            <IoLocationSharp
                              size={size}
                              color={colors.silver}
                            />
                          }
                        />
                        <AppButton
                          disabled={!form.client?._id || addLocButonDisabled}
                          text="Create Location"
                          className="text-primary btn-light"
                          onClick={addLocation}
                        />
                      </div>
                    </div>
                  )}
                </div>
              )}
            </div>
          </form>
        </Modal.Body>
        <Modal.Footer>
          <AppButton
            disabled={disabled}
            text="Create"
            form="form"
            onClick={handleSubmit}
            className="text-primary btn-light"
          />
        </Modal.Footer>
      </div>
    );
  };

  return { Body };
}
